export const formatPhoneNumber = (phone) => {
  if (!phone) return;
  phone = phone.replace(/^(\d)/, "+$1");

  const match = phone.match(/^\+(\d)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})(\d*)$/);
  if (!match) return phone;

  let formatted = `+${match[1]}`;
  if (match[2]) formatted += ` (${match[2]}`;
  if (match[2] && match[3]) formatted += `) ${match[3]}`;
  else if (match[3]) formatted += ` ${match[3]}`;
  if (match[4]) formatted += `-${match[4]}`;
  if (match[5]) formatted += `-${match[5]}`;
  if (match[6]) formatted += `${match[6]}`;

  return formatted;
}
